import React, { useEffect, useState } from 'react';
import classes from '../AllSites/allSitesSearchBar.module.css';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';
import sort from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sorting.png';
import { Dropdown } from 'primereact/dropdown';

// ── helpers ────────────────────────────────────────────────────

const toggle = (arr, val) =>
  arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];

const Section = ({ label, badge, open, onToggle, children }) => (
  <div className={classes.section}>
    <div className={classes.sectionHeader} onClick={onToggle}>
      <div className={classes.sectionHeaderLeft}>
        <span className={classes.sectionLabel}>{label}</span>
        {badge > 0 && <span className={classes.badge}>{badge}</span>}
      </div>
      <span className={`${classes.chevron} ${open ? classes.chevronOpen : ''}`}>▼</span>
    </div>
    {open && <div className={classes.sectionBody}>{children}</div>}
  </div>
);

const Pills = ({ options, selected, onToggle }) => (
  <div className={classes.pills}>
    {options.map(opt => (
      <button
        key={opt}
        type="button"
        className={`${classes.pill} ${selected.includes(opt) ? classes.pillActive : ''}`}
        onClick={() => onToggle(opt)}
      >
        {opt}
      </button>
    ))}
  </div>
);

const CheckRow = ({ label, checked, onChange }) => (
  <label className={classes.checkRow}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </label>
);

const INTEGRATION_TYPES = [
  { label: 'AJAX', value: 'AJAX' },
  { label: 'Dahua', value: 'DAHUA' },
  { label: 'Hikvision', value: 'HIKVISION' },
  { label: 'AIBox', value: 'AIBOX' },
  { label: 'Camect', value: 'CAMECT' },
];

// Mirrors the site_type / country_code option lists in DevicesList.js / CCTVIntegrationsList.js / Overview.js.
const SITE_TYPE_OPTIONS = [
  { key: 'RESIDENTIAL', label: 'Residential' },
  { key: 'OFFICE', label: 'Office' },
  { key: 'COMMERCIAL', label: 'Commercial' },
  { key: 'INDUSTRIAL', label: 'Industrial' },
  { key: 'CONSTRUCTION', label: 'Construction' },
  { key: 'WAREHOUSE', label: 'Warehouse / Storage' },
  { key: 'EDUCATION', label: 'Education' },
  { key: 'HEALTHCARE', label: 'Healthcare' },
  { key: 'PUBLIC', label: 'Public / Government' },
  { key: 'VACANT', label: 'Vacant property' },
  { key: 'UTILITY', label: 'Utility / Infrastructure' },
  { key: 'OTHER', label: 'Other' }
];

const COUNTRY_CODE_OPTIONS = [
  { code: 'GB', name: 'United Kingdom' },
  { code: 'IE', name: 'Ireland' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'DE', name: 'Germany' },
  { code: 'GR', name: 'Greece' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JP', name: 'Japan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MT', name: 'Malta' },
  { code: 'MX', name: 'Mexico' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NO', name: 'Norway' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Romania' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'KR', name: 'South Korea' },
  { code: 'ES', name: 'Spain' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TR', name: 'Turkey' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'VN', name: 'Vietnam' }
];

// ── Component ──────────────────────────────────────────────────

const CCTVIntegrationsSearchBar = (props) => {
  const {
    placeholder,
    onChange,
    value,
    handleFocus,
    handleBlur,
    showFilterButton,
    groups,
    online, setOnline,
    offline, setOffline,
    deviceTag, setDeviceTag,
    integrationTypes, setIntegrationTypes,
    connectionIssues, setConnectionIssues,
    armedState, setArmedState,
    outputStatus, setOutputStatus,
    multiCamectOnly, setMultiCamectOnly,
    multiCamectMismatchOnly, setMultiCamectMismatchOnly,
    siteActiveFilter, setSiteActiveFilter,
    siteType, setSiteType,
    siteLocation, setSiteLocation,
    groupName, setGroupName,
    sortField, setSortField,
    sortAsc, setSortAsc,
    submit, setSubmit,
    missedPollsFilter, setMissedPollsFilter
  } = props;

  const [showFilters, setShowFilters] = useState(false);
  const [showSorts, setShowSorts] = useState(false);
  const [openSections, setOpenSections] = useState({});

  // ── local filter state ──────────────────────────────────────
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localIntegrationTypes, setLocalIntegrationTypes] = useState(integrationTypes);
  const [localConnectionIssues, setLocalConnectionIssues] = useState(connectionIssues);
  const [localArmedState, setLocalArmedState] = useState(armedState ?? null);
  const [localOutputStatus, setLocalOutputStatus] = useState(outputStatus ?? null);
  const [localMultiCamectOnly, setLocalMultiCamectOnly] = useState(multiCamectOnly);
  const [localMultiCamectMismatchOnly, setLocalMultiCamectMismatchOnly] = useState(multiCamectMismatchOnly);
  const [localSiteActiveFilter, setLocalSiteActiveFilter] = useState(siteActiveFilter ?? null);
  const [localSiteType, setLocalSiteType] = useState(siteType ?? null);
  const [localSiteLocation, setLocalSiteLocation] = useState(siteLocation ?? null);
  const [localSortField, setLocalSortField] = useState(sortField ?? null);
  const [localSortAsc, setLocalSortAsc] = useState(sortAsc ?? 1);
  const [localMissedPollsFilter, setLocalMissedPollsFilter] = useState(missedPollsFilter ?? null)

  // Multi-select pill array
  const [siteStatusFilters, setSiteStatusFilters] = useState([]);

  // sync from props
  useEffect(() => {
    setLocalDeviceTag(deviceTag);
    setLocalGroupName(groupName);
    setLocalIntegrationTypes(integrationTypes);
    setLocalConnectionIssues(connectionIssues);
    setLocalArmedState(armedState ?? null);
    setLocalOutputStatus(outputStatus ?? null);
    setLocalMultiCamectOnly(multiCamectOnly);
    setLocalMultiCamectMismatchOnly(multiCamectMismatchOnly);
    setLocalSiteActiveFilter(siteActiveFilter ?? null);
    setLocalSiteType(siteType ?? null);
    setLocalSiteLocation(siteLocation ?? null);
    setLocalSortField(sortField ?? null);
    setLocalSortAsc(sortAsc ?? 1);
    setSiteStatusFilters([...(online ? ['Online'] : []), ...(offline ? ['Offline'] : [])]);
    setLocalMissedPollsFilter(missedPollsFilter ?? null);
  }, [online, offline, deviceTag, groupName, integrationTypes, connectionIssues, armedState, outputStatus, multiCamectOnly, multiCamectMismatchOnly, siteActiveFilter, siteType, siteLocation, sortField, sortAsc, missedPollsFilter]);

  const filterDefaults = {
    online: 0, offline: 0, deviceTag: null, groupName: null,
    integrationTypes: [], connectionIssues: 0, armedState: null, outputStatus: null,
    multiCamectOnly: 0, multiCamectMismatchOnly: 0, siteActiveFilter: null,
    siteType: null, siteLocation: null, sortField: null, sortAsc: 1, missedPollsFilter: null
  };

  const setters = {
    online: setOnline, offline: setOffline, deviceTag: setDeviceTag,
    groupName: setGroupName, integrationTypes: setIntegrationTypes,
    connectionIssues: setConnectionIssues, armedState: setArmedState,
    outputStatus: setOutputStatus, multiCamectOnly: setMultiCamectOnly,
    multiCamectMismatchOnly: setMultiCamectMismatchOnly, siteActiveFilter: setSiteActiveFilter,
    siteType: setSiteType, siteLocation: setSiteLocation,
    sortField: setSortField, sortAsc: setSortAsc, missedPollsFilter: setMissedPollsFilter
  };

  const SORT_OPTIONS = [
    { label: 'Date site made active', field: 'dateMadeActive' },
    { label: 'Portal name', field: 'tag' },
    { label: 'App name', field: 'deviceName' }
  ];

  const toggleSection = (key) =>
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));

  const handleClear = () => onChange({ target: { value: '' } });

  const handleShowFilters = () => { setShowFilters(p => !p); setShowSorts(false); };
  const handleShowSorts = () => { setShowSorts(p => !p); setShowFilters(false); };

  const HandleResetFilters = () => {
    setLocalDeviceTag(null);
    setLocalGroupName(null);
    setLocalIntegrationTypes([]);
    setLocalConnectionIssues(0);
    setLocalArmedState(null);
    setLocalOutputStatus(null);
    setLocalMultiCamectOnly(0);
    setLocalMultiCamectMismatchOnly(0);
    setLocalSiteActiveFilter(null);
    setLocalSiteType(null);
    setLocalSiteLocation(null);
    setLocalSortField(null);
    setLocalSortAsc(1);
    setSiteStatusFilters([]);
    setLocalMissedPollsFilter(null);

    Object.entries(setters).forEach(([key, setter]) => setter?.(filterDefaults[key]));

    setSubmit(submit + 1);
    setShowFilters(false);
    setShowSorts(false);
  };

  const HandleApplyFilters = () => {
    const payload = {
      online: siteStatusFilters.includes('Online') ? 1 : 0,
      offline: siteStatusFilters.includes('Offline') ? 1 : 0,
      deviceTag: localDeviceTag,
      groupName: localGroupName,
      integrationTypes: localIntegrationTypes,
      connectionIssues: localConnectionIssues,
      armedState: localArmedState,
      outputStatus: localOutputStatus,
      multiCamectOnly: localMultiCamectOnly,
      multiCamectMismatchOnly: localMultiCamectMismatchOnly,
      siteActiveFilter: localSiteActiveFilter,
      siteType: localSiteType,
      siteLocation: localSiteLocation,
      sortField: localSortField,
      sortAsc: localSortAsc,
      missedPollsFilter: localMissedPollsFilter
    };
    Object.entries(payload).forEach(([key, val]) => setters[key]?.(val));

    setShowFilters(false);
    setShowSorts(false);
    setSubmit(submit + 1);
  };

  // ── badge counts ────────────────────────────────────────────
  const statusBadge = siteStatusFilters.length + (localSiteActiveFilter !== null ? 1 : 0);
  const integrationBadge = localIntegrationTypes.length + (localConnectionIssues ? 1 : 0) + (localMultiCamectOnly === 1 ? 1 : 0) + (localMultiCamectMismatchOnly === 1 ? 1 : 0);
  const armedBadge = localArmedState !== null ? 1 : 0;
  const outputStatusBadge = localOutputStatus !== null ? 1 : 0;
  const groupBadge = localGroupName ? 1 : 0;
  const detailsBadge = (localDeviceTag ? 1 : 0) + (localSiteType ? 1 : 0) + (localSiteLocation ? 1 : 0);

  const clearFilter = (key) => {
    const setter = setters[key];
    if (setter !== undefined) setter(filterDefaults[key]);
    setSubmit(submit + 1);
  };

  const clearIntegrationType = (value) => {
    setIntegrationTypes(integrationTypes.filter(t => t !== value));
    setSubmit(submit + 1);
  };

  const activeChips = [
    online && { key: 'online', label: 'Online', onClear: () => clearFilter('online') },
    offline && { key: 'offline', label: 'Offline', onClear: () => clearFilter('offline') },
    siteActiveFilter === 1 && { key: 'siteActiveFilter', label: 'Active', onClear: () => clearFilter('siteActiveFilter') },
    siteActiveFilter === 0 && { key: 'siteActiveFilter', label: 'Inactive', onClear: () => clearFilter('siteActiveFilter') },
    ...integrationTypes.map(type => ({
      key: `integrationType:${type}`,
      label: INTEGRATION_TYPES.find(t => t.value === type)?.label ?? type,
      onClear: () => clearIntegrationType(type)
    })),
    connectionIssues && { key: 'connectionIssues', label: 'CCTV connection issues', onClear: () => clearFilter('connectionIssues') },
    armedState === 1 && { key: 'armedState', label: 'Disarmed', onClear: () => clearFilter('armedState') },
    armedState === 0 && { key: 'armedState', label: 'Armed', onClear: () => clearFilter('armedState') },
    outputStatus === 1 && { key: 'outputStatus', label: 'Output visible', onClear: () => clearFilter('outputStatus') },
    outputStatus === 0 && { key: 'outputStatus', label: 'Output not visible', onClear: () => clearFilter('outputStatus') },
    multiCamectMismatchOnly === 1 && { key: 'multiCamectMismatchOnly', label: 'Multiple Camects (mismatched states)', onClear: () => clearFilter('multiCamectMismatchOnly') },
    multiCamectMismatchOnly !== 1 && multiCamectOnly === 1 && { key: 'multiCamectOnly', label: 'Multiple Camects', onClear: () => clearFilter('multiCamectOnly') },
    groupName && { key: 'groupName', label: `Group: ${groupName}`, onClear: () => clearFilter('groupName') },
    deviceTag && { key: 'deviceTag', label: `Portal name: "${deviceTag}"`, onClear: () => clearFilter('deviceTag') },
    siteType && { key: 'siteType', label: `Site type: ${SITE_TYPE_OPTIONS.find(o => o.key === siteType)?.label ?? siteType}`, onClear: () => clearFilter('siteType') },
    siteLocation && { key: 'siteLocation', label: `Location: ${COUNTRY_CODE_OPTIONS.find(c => c.code === siteLocation)?.name ?? siteLocation}`, onClear: () => clearFilter('siteLocation') },
    sortField && { key: 'sortField', label: `Sort: ${SORT_OPTIONS.find(o => o.field === sortField)?.label ?? sortField} (${sortAsc ? 'asc' : 'desc'})`, onClear: () => clearFilter('sortField') },
    missedPollsFilter === 4 && { key: 'missedPollsFilter', label: 'CCTV Online', onClear: () => clearFilter('missedPollsFilter') },
    missedPollsFilter === 3 && { key: 'missedPollsFilter', label: 'CCTV Offline', onClear: () => clearFilter('missedPollsFilter') },
    missedPollsFilter === 5 && { key: 'missedPollsFilter', label: 'Stable', onClear: () => clearFilter('missedPollsFilter') },
    missedPollsFilter === 1 && { key: 'missedPollsFilter', label: 'Unstable', onClear: () => clearFilter('missedPollsFilter') },
    missedPollsFilter === 2 && { key: 'missedPollsFilter', label: 'Very unstable', onClear: () => clearFilter('missedPollsFilter') },
  ].filter(Boolean);

  const handleKeyPress = (event) => { if (event.key === 'Enter') event.preventDefault(); };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onKeyPress={handleKeyPress}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          spellCheck={false}
        />

        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">×</button>
          )}
          {showFilterButton !== false && (
            <button className={classes.filterButton} onClick={handleShowFilters} type="button">
              <img style={{ height: 30, width: 30 }} src={filters} />
            </button>
          )}
          {showFilterButton !== false && (
            <button className={classes.filterButton} onClick={handleShowSorts} type="button">
              <img style={{ height: 30, width: 30 }} src={sort} />
            </button>
          )}
        </div>

        {showFilters && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Filters</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>

            <div className={classes.panelBody}>

              {/* Status */}
              <Section label="Knowio Site Status" badge={statusBadge} open={openSections.status} onToggle={() => toggleSection('status')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Connectivity</span>
                  <Pills
                    options={['Online', 'Offline']}
                    selected={siteStatusFilters}
                    onToggle={v => setSiteStatusFilters(toggle(siteStatusFilters, v))}
                  />
                </div>

                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Active Status</span>
                  <Pills
                    options={['Active', 'Inactive']}
                    selected={localSiteActiveFilter === 1 ? ['Active'] : localSiteActiveFilter === 0 ? ['Inactive'] : []}
                    onToggle={v => {
                      if (v === 'Active') setLocalSiteActiveFilter(localSiteActiveFilter === 1 ? null : 1);
                      else setLocalSiteActiveFilter(localSiteActiveFilter === 0 ? null : 0);
                    }}
                  />
                </div>
              </Section>

              {/* CCTV Status*/}
              <Section label="CCTV Status" open={openSections.cctvStatus} onToggle={() => toggleSection('cctvStatus')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Connectivity</span>
                  <Pills 
                    options={['Online', 'Offline']}
                    selected={localMissedPollsFilter === 4 ? ['Online'] : localMissedPollsFilter === 3 ? ['Offline'] : []}
                    onToggle={v => {
                      if (v === 'Online') setLocalMissedPollsFilter(localMissedPollsFilter === 4 ? null : 4);
                      else setLocalMissedPollsFilter(localMissedPollsFilter === 3 ? null : 3);
                    }}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Stability</span>
                  <Pills 
                    options={['Stable', 'Unstable', "Very unstable"]}
                    selected={localMissedPollsFilter === 5 ? ['Stable'] : localMissedPollsFilter === 1 ? ['Unstable'] : localMissedPollsFilter === 2 ? ['Very unstable'] : []}
                    onToggle={v => {
                      if (v === 'Stable') setLocalMissedPollsFilter(localMissedPollsFilter === 5 ? null : 5);
                      else if (v === 'Unstable') setLocalMissedPollsFilter(localMissedPollsFilter === 1 ? null : 1);
                      else setLocalMissedPollsFilter(localMissedPollsFilter === 2 ? null : 2);
                    }}
                  />
                </div>
              </Section>

              {/* Integration type */}
              <Section label="Integration type" badge={integrationBadge} open={openSections.integration} onToggle={() => toggleSection('integration')}>
                <Pills
                  options={INTEGRATION_TYPES.map(t => t.label)}
                  selected={INTEGRATION_TYPES.filter(t => localIntegrationTypes.includes(t.value)).map(t => t.label)}
                  onToggle={label => {
                    const type = INTEGRATION_TYPES.find(t => t.label === label);
                    const next = toggle(localIntegrationTypes, type.value);
                    setLocalIntegrationTypes(next);
                    if (!next.includes('CAMECT')) {
                      setLocalMultiCamectOnly(0);
                      setLocalMultiCamectMismatchOnly(0);
                    }
                  }}
                />
                <CheckRow
                  label="Only show sites with CCTV connection issues"
                  checked={localConnectionIssues === 1}
                  onChange={() => setLocalConnectionIssues(localConnectionIssues === 1 ? 0 : 1)}
                />
                {localIntegrationTypes.includes('CAMECT') && (
                  <>
                    <CheckRow
                      label="Only show sites with more than one Camect"
                      checked={localMultiCamectOnly === 1}
                      onChange={() => {
                        const next = localMultiCamectOnly === 1 ? 0 : 1;
                        setLocalMultiCamectOnly(next);
                        if (next === 0) setLocalMultiCamectMismatchOnly(0);
                      }}
                    />
                    {localMultiCamectOnly === 1 && (
                      <div style={{ paddingLeft: '20px' }}>
                        <CheckRow
                          label="...where their states don't match (e.g. one armed, one disarmed)"
                          checked={localMultiCamectMismatchOnly === 1}
                          onChange={() => setLocalMultiCamectMismatchOnly(localMultiCamectMismatchOnly === 1 ? 0 : 1)}
                        />
                      </div>
                    )}
                  </>
                )}
              </Section>

              {/* Armed / Disarmed */}
              <Section label="Armed / Disarmed" badge={armedBadge} open={openSections.armed} onToggle={() => toggleSection('armed')}>
                <Pills
                  options={['Armed', 'Disarmed']}
                  selected={localArmedState === 0 ? ['Armed'] : localArmedState === 1 ? ['Disarmed'] : []}
                  onToggle={v => {
                    if (v === 'Armed') setLocalArmedState(localArmedState === 0 ? null : 0);
                    else setLocalArmedState(localArmedState === 1 ? null : 1);
                  }}
                />
              </Section>

              {/* Output status */}
              <Section label="Output status" badge={outputStatusBadge} open={openSections.outputStatus} onToggle={() => toggleSection('outputStatus')}>
                <Pills
                  options={['Visible', 'Not visible']}
                  selected={localOutputStatus === 1 ? ['Visible'] : localOutputStatus === 0 ? ['Not visible'] : []}
                  onToggle={v => {
                    if (v === 'Visible') setLocalOutputStatus(localOutputStatus === 1 ? null : 1);
                    else setLocalOutputStatus(localOutputStatus === 0 ? null : 0);
                  }}
                />
              </Section>

              {/* Group */}
              <Section label="Group" badge={groupBadge} open={openSections.group} onToggle={() => toggleSection('group')}>
                <div className={classes.fieldRow}>
                  <Dropdown
                    value={localGroupName}
                    className="w-full md:w-14rem"
                    style={{ width: '100%' }}
                    onChange={(e) => setLocalGroupName(e.value)}
                    options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                    placeholder="Choose group"
                    filter
                    showClear
                  />
                </div>
              </Section>

              {/* Site details */}
              <Section label="Site details" badge={detailsBadge} open={openSections.details} onToggle={() => toggleSection('details')}>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Portal name contains</span>
                  <input
                    className={classes.textInput}
                    placeholder="Enter keyword..."
                    value={localDeviceTag || ''}
                    onChange={e => setLocalDeviceTag(e.target.value)}
                  />
                </div>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Site type</span>
                  <Dropdown
                    value={localSiteType}
                    className="w-full md:w-14rem"
                    style={{ width: '100%' }}
                    onChange={(e) => setLocalSiteType(e.value)}
                    options={SITE_TYPE_OPTIONS}
                    optionLabel="label"
                    optionValue="key"
                    placeholder="Any site type"
                    showClear
                  />
                </div>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Site location</span>
                  <Dropdown
                    value={localSiteLocation}
                    className="w-full md:w-14rem"
                    style={{ width: '100%' }}
                    onChange={(e) => setLocalSiteLocation(e.value)}
                    options={COUNTRY_CODE_OPTIONS}
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Any location"
                    filter
                    showClear
                  />
                </div>
              </Section>

            </div>
          </div>
        )}

        {showSorts && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Sort</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>
            <div className={classes.panelBody} style={{ padding: '14px 18px' }}>
              <div className={classes.subSection}>
                <span className={classes.subLabel}>Sort by</span>
                <div className={classes.sortGrid}>
                  {SORT_OPTIONS.map(({ label, field }) => (
                    <button
                      key={field}
                      type="button"
                      className={`${classes.sortPill} ${localSortField === field ? classes.sortPillActive : ''}`}
                      onClick={() => setLocalSortField(localSortField === field ? null : field)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div className={classes.subSection} style={{ marginTop: 10 }}>
                <span className={classes.subLabel}>Direction</span>
                <div className={classes.directionRow}>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 1 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(1)}
                  >
                    ↑ Ascending
                  </button>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 0 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(0)}
                  >
                    ↓ Descending
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {activeChips.length > 0 && (
        <div className={classes.activeFilters}>
          {activeChips.map(({ key, label, onClear }) => (
            <span key={key} className={classes.filterChip}>
              {label}
              <button className={classes.filterChipClear} onClick={onClear} type="button">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CCTVIntegrationsSearchBar;
